/* eslint-disable no-restricted-imports */
import React, { useMemo } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useIntl } from "react-intl";
import { isEqual } from "lodash";
import { shallowEqual, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { useFilterObjectsUIContext } from "../../pages/FilterObjectsUIContext";

// Validation schema
const SpecificationEditSchema = Yup.object().shape({
  // value: Yup.string()
  //   .min(2, "Minimum 2 symbols")
  //   .max(50, "Maximum 50 symbols")
  //   .required("Value is required"),
  // specId: Yup.number().required("Specification type is required"),
});

export function SpecificationEditForm({
  saveSpecification,
  specification,
  actionsLoading,
  onHide,
  formFields,
  ObjectEditSchema,
  isFullAccess = false,
  prepareFilter
}) {

  const intl = useIntl();


  const filterUIContext = useFilterObjectsUIContext();
  const objectsUIProps = useMemo(() => {
    return {
      queryParams: filterUIContext.queryParams,
      setQueryParams: filterUIContext.setQueryParams,
    };
  }, [filterUIContext]);

  const createFields = (
    field,
    index,
    setFieldValue,
    values,
    handleSubmit,
    onChange
  ) => {
    if (field.disabled === undefined) field.disabled = false;
    if (field.type === "localSelect") {
      return (
        <div key={field.rowIdx} className={"col-lg-12 mb-4"}>
          <label>{field.label}</label>
          <select
            className="form-control"
            placeholder={field.placeholder}
            name={field.name}
            disabled={!isFullAccess}
            // label={intl.formatMessage({ id: field.label })}
            // onBlur={handleBlur}
            onChange={(e) => {
              setFieldValue(field.name, e.target.value);
            }}
            value={values[field.name]}
          >
            {field.list.map((opt, idx) => <option key={idx} value={opt.value}>{opt.lable}</option>)}

          </select>
        </div>
      );
    }
    else if (field.type === "select") {
      return (
        <div key={field.rowIdx} className={"col-lg-12 mb-4"}>
          <Field
            name={field.name}
            component={field.component}
            placeholder={intl.formatMessage({ id: field.placeholder })}
            label={intl.formatMessage({ id: field.label })}
            disabled={!isFullAccess}
            type={field.type}
            as={field.as}
            // disabled={!isFullAccess || !field.disabled}
            onChange={(e) => {
              handleChangeLocal({
                val: e.currentTarget.value,
                field,
                setFieldValue,
                values,
              });
            }}
          // value={values[field.name]}
          />
        </div>
      );
    }
    else {
      return (
        <div key={field.rowIdx} className={"col-lg-12 mb-4"}>
          <Field
            name={field.name}
            component={field.component}
            disabled={!isFullAccess}
            placeholder={intl.formatMessage({ id: field.placeholder })}
            label={intl.formatMessage({ id: field.label })}
            type={field.type}
            as={field.as}
          // disabled={!isFullAccess || !field.disabled}
          // value={values[field.name]}
          />
        </div>
      );
    }
  };

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(objectsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, objectsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      newQueryParams.skipCount = 0;
      objectsUIProps.setQueryParams(newQueryParams);
    }
  };

  const handleChangeLocal = ({ val, field, setFieldValue, values }) => {
    const temp = { ...specification };
    temp[field.name] = val;
    setFieldValue(field.name, +val);
    field.relField.forEach((element) => {
      setFieldValue(element, 0);
      temp[element] = 0;
    });

    values = {
      ...values,
      ...field.relValues,
    };

    values[field.name] = +val;

    applyFilter(temp);
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={specification}
        validationSchema={ObjectEditSchema}
        onSubmit={(values) => {
          saveSpecification(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, onChange }) => (
          <>
            <Modal.Body className="overlay overlay-block cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                {formFields.map((formRow) => (
                  <div key={formRow.row} className="form-group row">
                    {formRow.list.map(
                      (field, index) =>
                        createFields(
                          field,
                          index,
                          setFieldValue,
                          values,
                          handleSubmit,
                          onChange
                        )
                    )}
                  </div>
                ))}
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate"
              >
                انصراف
              </button>
              <> </>
              <button
                type="submit"
                onClick={() => handleSubmit()}
                className="btn btn-primary btn-elevate"
                disabled={!isFullAccess}
              >
                ذخیره
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}